export const ExternalAccessTypes = () => {
  return {
    ALL: {
      name: 'ALL',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
      },
    },
    t1sales: {
      name: 'T1 Box-Office',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        BOXOFFICE_ADD_TO_CART: {
          name: 'Box-office: Add to Cart',
          parameters: {
            forDepartmentIds: {
              name: 'Department IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        BOXOFFICE_ADD_TO_CART_AS_COMP: {
          name: 'Box-office: Add to Cart as COMP',
          parameters: {
            forDepartmentIds: {
              name: 'Department IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
      },
    },
    portal: {
      name: 'Client Portal',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        VIEW_EVENT_LIST: {
          name: 'View Event List',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        VIEW_PROMO_LIST: {
          name: 'View Discount List',
          parameters: {
            forDiscountIds: {
              name: 'Discount IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        VIEW_PROMO_SINGLE_USE_SET: {
          name: 'View Discount Single-Use Codes',
          parameters: {},
        },
        DEPARTMENT_EXPORT_REPORTS: {
          name: 'Department Export Reports',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        VIEW_ORDER_LIST: {
          name: 'View Order List',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        VIEW_ORDER_DETAILS: {
          name: 'View Order Details',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        MODIFY_ORDER_DETAILS: {
          name: 'Modify Order Details',
          parameters: {},
        },
        REFUND_ORDER_T1ONLY: {
          name: 'Refund Order: T1 Only',
          parameters: {
            forSalesContext: {
              name: 'Sales Contexts',
              regex: '^(POS|ECOMMERCE|BOXOFFICE)(,(POS|ECOMMERCE|BOXOFFICE))*$',
              placeholder: "eg. 'POS,ECOMMERCE'",
            },
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        REFUND_ORDER_GATEWAY: {
          name: 'Refund Order: T1 and Gateway',
          parameters: {
            forSalesContext: {
              name: 'Sales Contexts',
              regex: '^(POS|ECOMMERCE|BOXOFFICE)(,(POS|ECOMMERCE|BOXOFFICE))*$',
              placeholder: "eg. 'POS,ECOMMERCE'",
            },
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        CORPORATE_READ_ONLY: {
          name: 'View Corporate Customers/Applications',
          parameters: {},
        },
        CORPORATE_FULL_ACCESS: {
          name: 'View and Modify Corporate Customers/Applications',
          parameters: {
            forLandingPageIds: {
              name: 'Special Access Type IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        QUICK_COMP_ACCESS: {
          name: 'Access Quick COMP',
          parameters: {
            forLandingPageIds: {
              name: 'Special Access Type IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        TICKET_PARTNER_ASSIGNMENT: {
          name: 'Assign Tickets to Partners',
          parameters: {},
        },
        CANCEL_TICKETS_ACCESS: {
          name: 'Cancel Tickets',
          parameters: {},
        },
        CUSTOMER_PROFILES_ACCESS: {
          name: 'View Customer Profiles',
          parameters: {},
        },
        TICKET_LOOKUP_ACCESS: {
          name: 'Pass Lookup',
          parameters: {},
        },
      },
    },
    portalreports: {
      name: 'Client Portal Reports',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        SALES_REPORT_ACCESS: {
          name: 'Access to the Sales Report',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        SALES_BY_GATEWAY_REPORT_ACCESS: {
          name: 'Access to the Sales by Gateway Report',
          parameters: {
            forEventIds: {
              name: 'Event IDs',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
            },
          },
        },
        SESSION_REPORT_ACCESS: {
          name: 'Access to the Session Report for dated events',
          parameters: {},
        },
        SETTLEMENT_REPORT_ACCESS: {
          name: 'Access to the Settlement Report',
          parameters: {},
        },
        REFUND_REPORT_ACCESS: {
          name: 'Access to the Refund Report',
          parameters: {},
        },
        DISCOUNT_REPORT_ACCESS: {
          name: 'Access to the Discount Report',
          parameters: {},
        },
        FLASH_REPORT_ACCESS: {
          name: 'Access to the Flash Report',
          parameters: {},
        },
        GATE_SALES_REPORT: {
          name: 'Access to the Gate Sales Report',
          parameters: {},
        },
        DONATIONS_REPORT_ACCESS: {
          name: 'Access to the Donations Report',
          parameters: {},
        },
        DASHBOARD_REPORT_ACCESS: {
          name: 'Access to the Dashboard Report',
          parameters: {},
        },
        SCAN_REPORT_ACCESS: {
          name: 'Access to the Scan Report',
          parameters: {},
        },
        SCAN_VARIANCE_REPORT_ACCESS: {
          name: 'Access to the Scan Variance Report',
          parameters: {},
        },
        EVENT_SALES_REPORT_ACCESS: {
          name: 'Access to the Event Sales Report',
          parameters: {},
        },
        EMAIL_LIST_ACCESS: {
          name: 'Access to the Email List Report',
          parameters: {},
        },
        PARTNER_TRACKING_REPORT_ACCESS: {
          name: 'Access to the Partner Tracking Report',
          parameters: {},
        },
        PURCHASER_POSTAL_LOCATION_REPORT_ACCESS: {
          name: 'Postal Code Location Report (kepler.gl)',
          parameters: {},
        },
        FILES_REPORT_ACCESS: {
          name: "Access to the Client 'Files' in the Portal",
          parameters: {},
        },
        CUSTOM_FIELD_REPORT_ACCESS: {
          name: 'Access to the Custom Field Report',
          parameters: {},
        },
        SEATMAP_OVERVIEW_REPORT_ACCESS: {
          name: 'Access to the Seatmap Overview Report',
          parameters: {},
        },
      },
    },
    agconnect: {
      name: 'AG Connect',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        EVENT_EMAILER_ACCESS: {
          name: 'Event Emailer',
          parameters: {},
        },
        SOCIAL_MEDIA: {
          name: 'Social Media',
          parameters: {},
        },
      },
    },
    onsite: {
      name: 'On-Site App',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        PUNCH_CLOCK: {
          name: 'Punch Clock',
          parameters: {
            forEventIds: {
              name: 'EMS Events',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
              picker: 'emsEvents',
            },
          },
        },
        PUNCH_CLOCK_SCHEDULE: {
          name: 'Schedule',
          parameters: {
            forEventIds: {
              name: 'EMS Events',
              regex: '^[0-9]+(,[0-9]+)*$',
              placeholder: "eg. '1,2,3'",
              picker: 'emsEvents',
            },
          },
        },
        SCANNER: {
          name: 'Scanner',
          parameters: {},
        },
        ORDER_LOOKUP: {
          name: 'Order Lookup',
          parameters: {},
        },
        EVENT_INFO: {
          name: 'Event Info',
          parameters: {},
        },
        GUEST_LIST: {
          name: 'Guest List',
          parameters: {},
        },
        ISSUE_REFUND: {
          name: 'Issue Refund',
          parameters: {},
        },
        ROOM_COUNTER: {
          name: 'Room Counter',
          parameters: {},
        },
        NOTES: {
          name: 'Notes',
          parameters: {},
        },
        GATEKEEPER: {
          name: 'Gatekeeper',
          parameters: {},
        },
        CASHROOM_CHANGE: {
          name: 'Cashroom Change System',
          parameters: {},
        },
        RUNNER_MANAGER_ACCESS: {
          name: 'Cashroom Runner: Manager',
          parameters: {},
        },
        RUNNER_RUNNER_ACCESS: {
          name: 'Cashroom Runner: Runner',
          parameters: {},
        },
        RUNNER_CASHROOM_ACCESS: {
          name: 'Cashroom Runner: Cashroom Access',
          parameters: {},
        },
      },
    },
    concessions: {
      name: 'Concession Reporting',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        VIEW_SEASONS: {
          name: 'View Seasons',
          parameters: {},
        },
        CRUD_SEASONS: {
          name: 'Manage Seasons',
          parameters: {},
        },
        VIEW_COMPANIES: {
          name: 'View Companies',
          parameters: {},
        },
        CRUD_COMPANIES: {
          name: 'Manage Companies',
          parameters: {},
        },
        VIEW_RENTALS: {
          name: 'View Rentals',
          parameters: {},
        },
        CRUD_RENTALS: {
          name: 'Manage Rentals',
          parameters: {},
        },
        VIEW_TRANSACTIONS: {
          name: 'View Transactions',
          parameters: {},
        },
        CRUD_TRANSACTIONS: {
          name: 'Manage Transactions',
          parameters: {},
        },
        VIEW_DEVICES: {
          name: 'View Devices',
          parameters: {},
        },
        CRUD_DEVICES: {
          name: 'Manage Devices',
          parameters: {},
        },
      },
    },
    cashroom: {
      name: 'Cashroom',
      operations: {
        ALL: {
          name: 'ALL',
          parameters: {},
        },
        CASHROOM_AUDIT_ACCESS: {
          name: 'Read Only Access to the Cashroom',
          parameters: {},
        },
        CASHROOM_FULL_ACCESS: {
          name: 'Full Access to the Cashroom',
          parameters: {},
        },
        CASHROOM_CLERK_ACCESS: {
          name: 'Clerk Access to the Cashroom',
          parameters: {},
        },
      },
    },
  }
}
